import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { hostingManagementOptions } from '../../schemas';

export function HostingManagementInput({ isEditable, className }: { isEditable?: boolean; className?: string }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="hosting_management"
      render={({ field }) => (
        <FormSelect
          value={field.value}
          onChange={field.onChange}
          disabled={!isEditable}
          label="Hosting Management"
          options={hostingManagementOptions}
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.name}
          formItemClassName={className}
        />
      )}
    />
  );
}
